import React        from 'react';
import Link         from 'next/link';

export default class PartnersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            partners: [
                {
                    title: 'Сервис Бригадир',
                    position: 'Строительные',
                    desc: 'Удобный сервис для прорабов и сотрудников офиса, позволяющий контролировать процесс строительства.',
                    link: 'https://brigadierapp.ru',
                    linkName: 'brigadierapp.ru',
                    img: '/static/img/partners/logo_brigadir.svg',
                    typeId: 2
                },
                {
                    title: 'Тинькофф банк',
                    position: 'Финансовые',
                    desc: 'Российский коммерческий банк, который полностью отказался от розничных отделений. Все банковские операции мгновенно проводятся по телефону или через интернет.',
                    link: 'https://www.tinkoff.ru',
                    linkName: 'tinkoff.ru',
                    img: '/static/img/partners/logo_tinkoff.svg',
                    typeId: 1
                },
                {
                    title: 'Альфа-банк',
                    position: 'Финансовые',
                    desc: 'Крупнейший частный банк в России, осуществляющий все основные виды банковских операций.',
                    link: 'https://alfabank.ru',
                    linkName: 'alfabank.ru',
                    img: '/static/img/partners/logo_alfa-bank.svg',
                    typeId: 1
                },
                {
                    title: 'Michelin',
                    position: 'Транспортные',
                    desc: 'Французский производитель шин, один из крупнейших в своей области.',
                    link: 'https://www.michelin.ru',
                    linkName: 'michelin.ru',
                    img: '/static/img/partners/logo_michelin.svg',
                    typeId: 3
                },
                {
                    title: 'Райффайзен Банк',
                    position: 'Финансовые',
                    desc: 'Дочерняя структура крупного австрийского банковского холдинга «Райффайзен Банк Интернациональ АГ». Банк является универсальной кредитной организацией, предлагающей широкий спектр услуг корпоративным и частным клиентам.',
                    link: 'https://www.raiffeisen.ru',
                    linkName: 'raiffeisen.ru',
                    img: '/static/img/partners/logo_raiffeisen.svg',
                    typeId: 1
                },
                {
                    title: 'Карта рассрочки Халва',
                    position: 'Финансовые',
                    desc: 'Платежная карта от Совкомбанка, дающая возможность совершать ежедневные покупки в рассрочку до 36 месяцев без первоначального взноса, комиссий и переплат в магазинах-партнерах.',
                    link: 'https://halvacard.ru',
                    linkName: 'halvacard.ru',
                    img: '/static/img/partners/logo_halva.svg',
                    typeId: 1
                },
                {
                    title: 'Uniteller',
                    position: 'Финансовые',
                    desc: 'Uniteller – российская процессинговая компания, оказывающая все виды услуг эквайринга, включая традиционные кассовые решения для ритейла, прием банковских карт в системах самообслуживания и интернет-эквайринг. Процессинговый центр Uniteller соответствует требованиям стандарта безопасности данных индустрии платежных карт PCI DSS, решения компании сертифицированы в соответствии с требованиями PCI PA-DSS.',
                    link: 'https://uniteller.ru',
                    linkName: 'uniteller.ru',
                    img: '/static/img/partners/uniteller.jpg',
                    typeId: 1
                }
            ]
        };
    }

    renderList = (item, index) => {
        const { tabType } = this.props;

        return (
            <div className={"job-item t-partners" + (tabType === 0 ? "" : (tabType !== item.typeId ? " is-hide" : ""))} key={index} data-type-id={item.typeId}>
                <div className="container">
                    <div className="job-item-inner">
                        <Link href={item.link} target='_blank'>
                            <img src={item.img} alt="" className="job-item-img"/>
                        </Link>
                        <div className="job-item-cnt">
                            <div className="job-item-head">
                                <h3 className="title">
                                    <Link href={item.link}>
                                        <a target='_blank'>{item.title}</a>
                                    </Link>
                                </h3>
                                <span className="position">{item.position}</span>
                            </div>
                            <p className="job-item__desc">
                                {item.desc}
                            </p>
                            <div className="job-item-link">
                                <a href={item.link} className="job-item__link">{item.linkName}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    render() {
        const { partners } = this.state;

        return (
            <div className="job-cnt">
                {partners.map(this.renderList)}
            </div>
        );
    }
}
